export default __webpack_public_path__ + "static/media/button-mini-search.bb320754.svg";